import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, inr } from "@/lib/api";

const today = () => new Date().toLocaleDateString("en-CA");

export const DailyEntryDialog = ({ group, accounts, onOpenChange, onSave }) => {
  const [date, setDate] = useState(today());
  const [vals, setVals] = useState({});

  useEffect(() => {
    if (!group || !date) return;
    api.get("/entries", { params: { date_from: date, date_to: date } }).then((r) => {
      const m = {};
      r.data.filter((e) => e.group_id === group.id && e.account_id).forEach((e) => { m[e.account_id] = String(e.amount); });
      setVals(m);
    });
  }, [group, date]);

  const total = Object.values(vals).reduce((s, v) => s + (parseFloat(v) || 0), 0);
  const items = accounts.filter((a) => vals[a.id] !== undefined && vals[a.id] !== "")
    .map((a) => ({ account_id: a.id, amount: parseFloat(vals[a.id]) }));

  return (
    <Dialog open={!!group} onOpenChange={onOpenChange}>
      <DialogContent data-testid="daily-entry-dialog" className="sm:max-w-lg" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle className="font-head text-2xl uppercase">{group?.name} · Daily entry</DialogTitle>
        </DialogHeader>
        <div className="flex items-center gap-3">
          <span className="text-sm text-slate-500">Date</span>
          <Input data-testid="daily-date-input" type="date" value={date} onChange={(e) => setDate(e.target.value)} className="font-mono w-44" />
        </div>
        <div className="border rounded-lg divide-y max-h-[50vh] overflow-y-auto">
          {accounts.map((a) => (
            <div key={a.id} className="flex items-center gap-3 px-3 py-2">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate">{a.site_name}</p>
                <p className="text-xs font-mono text-slate-500">{a.user_code}</p>
              </div>
              <Input data-testid={`daily-amount-${a.id}`} type="number" step="0.01" placeholder="₹ 0.00" className="font-mono w-36 text-right"
                value={vals[a.id] ?? ""} onChange={(e) => setVals({ ...vals, [a.id]: e.target.value })} />
            </div>
          ))}
        </div>
        <DialogFooter className="items-center sm:justify-between">
          <span data-testid="daily-total" className="font-mono font-bold text-emerald-700">Total {inr(total)}</span>
          <Button data-testid="daily-save-btn" disabled={!items.length} className="bg-sky-600 hover:bg-sky-700"
            onClick={() => onSave({ group_id: group.id, entry_date: date, items })}>Save entries</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
